import type { GetPollResults200MostVotedOption } from './getPollResults200MostVotedOption';
import type { GetPollResults200OptionsItem } from './getPollResults200OptionsItem';

/**
 * 투표 결과 정보 (결과 포함)
 */
export type GetPollResults200 = {
  durationMinutes?: number;
  expiresAt?: string;
  isExpired: boolean;
  /**
   * 투표 결과의 선택지 정보
   * @nullable
   */
  mostVotedOption?: GetPollResults200MostVotedOption;
  /** 투표 선택지 목록 및 결과 (% 포함) */
  options: GetPollResults200OptionsItem[];
  pollId: string;
  question: string;
  totalVotes: number;
  /** @nullable */
  userVotedOptionId?: string | null;
};
